module.exports = __webpack_public_path__ + "school/img/hanxuexiaopu.2345e597.jpg";